import { render, staticRenderFns } from "./OrderTmsModal.vue?vue&type=template&id=c77bb92e&scoped=true&"
import script from "./OrderTmsModal.vue?vue&type=script&lang=js&"
export * from "./OrderTmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77bb92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c77bb92e')) {
      api.createRecord('c77bb92e', component.options)
    } else {
      api.reload('c77bb92e', component.options)
    }
    module.hot.accept("./OrderTmsModal.vue?vue&type=template&id=c77bb92e&scoped=true&", function () {
      api.rerender('c77bb92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/OrderTmsModal.vue"
export default component.exports